<template>
	<div class="form-group group-checkbox-week-days">
		<label :for="name">{{ placeholder }}</label>
		<div class="items">
			<label v-for="option in options" :key="option.value" class="item">
				<input type="checkbox" :name="name" :id="option.text" :value="option.value" v-model="selected" @change="onChange" v-validate="rules" :data-vv-as="placeholder">
				<span class="day">{{ option.text }}</span>
			</label>
		</div>
		<span v-if="rules" v-show="errors.has(name)" class="text-danger">{{ errors.first(name) }}</span>
	</div>
</template>

<script>
export default {
	inject: ['$validator'],
	props: [
		'value',
		'name',
		'placeholder',
		'rules'
	],
	data () {
		return {
			options: [
				{ text: this.$t('labels.week.mon'), value: 1  },
				{ text: this.$t('labels.week.tue'), value: 2  },
				{ text: this.$t('labels.week.wed'), value: 4  },
				{ text: this.$t('labels.week.thu'), value: 8  },
				{ text: this.$t('labels.week.fri'), value: 16 },
				{ text: this.$t('labels.week.sat'), value: 32 },
				{ text: this.$t('labels.week.sun'), value: 64 }
			],
			selected: []
		}
	},
	watch: {
		value () {
			this.selected = []
			this.options.forEach(element => {
				if (element.value & this.value) {
					this.selected.push(element.value)
				}
			})
		}
	},
	computed: {
		result () {
			if (this.selected.length) {
				return this.selected.reduce(function (acc, val) {
					return acc + val
				})
			}
			return 0
		}
	},
	methods: {
		onChange () {
			this.$emit('input', this.result)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/pillboxV2/InputWeek.vue